<div class="component-container">
  <div
    class="row w-full flex flex-col flex-wrap md:flex-row md:space-x-[2rem] justify-center items-center">
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['role']"
      [options]="roleFilterList"
      [parentFormGroup]="form"
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      controlName="role"
      label="Role"
      placeholder="Select all that apply"
      type="small"
    />
    <app-dropdown
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      [parentFormGroup]="form"
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['session']"
      [options]="sessionFilterList"
      [enableClearSelection]="true"
      controlName="session"
      label="Sessions"
      placeholder="Select one"
      type="small"
    />
    <app-dropdown
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      [parentFormGroup]="form"
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['status']"
      [options]="statusFilterList"
      [enableMultiple]="true"
      [enableClearSelection]="true"
      controlName="status"
      label="Status"
      placeholder="Select one"
      type="small"
    />

    <div class="vertical hidden md:block"></div>

    <app-text-input
      class="input w-full md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] search-input flex-grow"
      [parentFormGroup]="form"
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['searchText']"
      (handleSuffixClick)="apply()"
      suffixIcon="search"
      controlName="searchText"
      label="Search"
      placeholder="Search by name"
      type="small"
      [minLength]="0"
    ></app-text-input>

    <div class="vertical hidden md:block"></div>

    <app-primary-button
      type="small"
      class="btn lg:w-[10%] md:w-[10%] w-full md:mt-[2rem] mb-[2rem] mb:mb-0"
      (handleClick)="apply()"
      [isDisabled]="!form.dirty"
    >
      Apply
    </app-primary-button>
  </div>
</div>
